import AuthConfirmAccount from "./auth-confirm-account";

export default AuthConfirmAccount;